import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { useAppDispatch } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import CRMSettingsComponent from '../components/crm-settings.component';
import { selectCrmSettingsQueryItems } from '../../../../../redux/crm-settings/selector';
import { crmSettings } from '../../../../../redux/crm-settings/action';

const ManagementCRMSettings = () => {
  const dispatch = useAppDispatch()
  const crmSettingsQuery = useSelector(selectCrmSettingsQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [selectCRMSettings, setSelectCRMSettings] = useState<any>([])

  const fetchCRMSettingsQueryById = () => {
    dispatch(crmSettings.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/crm/crm-settings/query`,
      entity: 'crmSettings',
      jsonData: {
        Records: [
          {
            Id: 0
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectCRMSettings({ ...selectCRMSettings, [fields[0]]: value });
  }

  useEffect(
    () => {
      fetchCRMSettingsQueryById()
      setIsLoading(false)
    }, []
  )

  useEffect(
    () => {
      if (isQuery) {
        setSelectCRMSettings(crmSettingsQuery?.result?.items)
      }
    }, [isQuery]
  )

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    await dispatch(crmSettings.resetAction({ actionType: 'update' }))
    await dispatch(crmSettings.update({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/crm/crm-settings`,
      entity: 'crmSettings',
      jsonData: {
        Records: [
          selectCRMSettings
        ]
      }
    }))
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <CRMSettingsComponent
          handleInnerFormChange={handleInnerFormChange}
          selectCRMSettings={selectCRMSettings}
          handleFormSubmit={handleFormSubmit}
        />
      }
    </>
  )
};

export default ManagementCRMSettings;